var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-file-input',{attrs:{"multiple":"","prepend-icon":"mdi-camera"},on:{"change":_vm.select},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }